// @ts-check

import { useState } from "react";
import { Input, Modal } from "antd";
import Button from '~/components/Shared/Button';
import { kiosk_create_activation_key, kiosk_update_activation_key } from '~/api/zero-api';
import { getErrorMessageFromResponse } from '~/other/Helper';

/**
 * @param {Object} props
 * @param {() => void} props.cancel
 * @param {(kioskActivationKey: KioskActivationKey) => void} props.onSuccess
 * @param {KioskActivationKey} [props.existingLink]
 */
const KioskLinkModal = ({ cancel, onSuccess, existingLink }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [code, setCode] = useState("");

    const handleCreate = async () => {
        setError(null);

        if (code.length !== 0 && code.length < 4) {
            setError("Activation code must be at least 4 characters long.");
            return;
        }

        try {
            setLoading(true);
            const body = { activation_code: code };
            const req = () =>
                !!existingLink
                    ? kiosk_update_activation_key(existingLink.uuid, body)
                    : kiosk_create_activation_key(body);
            const res = await req();
            const data = await res.json();
            onSuccess(data);
        } catch (err) {
            const msg = await getErrorMessageFromResponse(
                err,
                `Could not ${existingLink ? "update" : "create"} kiosk activation link.`
            );
            setError(msg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title={existingLink ? "Edit Kiosk Link" : "Create Kiosk Link"}
            open
            maskClosable={false}
            onCancel={cancel}
            maskTransitionName="maskTransitionName"
            footer={
                <div>
                    <Button onClick={cancel}>Cancel</Button>
                    <Button type="primary" onClick={handleCreate} loading={loading}>
                        {existingLink ? "Update" : "Create"}
                    </Button>
                </div>
            }
        >
            <p className="zero-dark-grey">
                {existingLink
                    ? "Change the code below, or leave it blank to disable the code requirement."
                    : "Enter an activation code (optional). This code will be used to access the Kiosk Mode login screen."}
            </p>
            <Input
                placeholder="Activation Code"
                type="password"
                autoComplete="off"
                value={code}
                onChange={(e) => setCode(e.target.value)}
            />
            {error && <small className="error">{error}</small>}
        </Modal>
    );
};

export default KioskLinkModal;
